<template>
    <div class="ttl-editor">
        <h4 style="margin-bottom: 8px;">
            <a-icon type="clock-circle" style="margin-right: 8px;" />
            Message Time-to-Live (TTL) • Optional
        </h4>
        <p class="ttl-description">
            {{ getTtlDescription }}
        </p>
        
        <div class="ttl-input-row">
            <a-select
                :value="value"
                @change="handleChange"
                style="width: 100%"
                placeholder="Select TTL or leave default"
                allowClear
            >
                <a-select-option
                    v-for="option in getTtlOptions"
                    :key="option.value"
                    :value="option.value"
                >
                    {{ option.label }}
                </a-select-option>
            </a-select>
        </div>
        
        <div class="ttl-info">
            <a-icon type="info-circle" style="margin-right: 4px; color: #1890ff;" />
            <span>{{ getTtlInfoText }}</span>
        </div>
    </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
    name: "TTLEditor",
    props: {
        value: { type: Number, default: null },
        category: { type: String, required: true },
    },
    computed: {
        getTtlDescription() {
            const descriptions = {
                MARKETING: "If we are unable to deliver your marketing message, we will retry for the specified time period.",
                UTILITY: "Set how long we should attempt to deliver utility messages like order confirmations or receipts.",
                AUTHENTICATION: "Define how long authentication codes remain valid for delivery.",
            };
            return descriptions[this.category] || "";
        },
        getTtlOptions() {
            const options = {
                MARKETING: [
                    { value: 43200, label: "12 hours (43,200 seconds)" },
                    { value: 86400, label: "1 day (86,400 seconds)" },
                    { value: 259200, label: "3 days (259,200 seconds)" },
                    { value: 604800, label: "7 days (604,800 seconds)" },
                    { value: 1296000, label: "15 days (1,296,000 seconds)" },
                    { value: 2592000, label: "30 days (2,592,000 seconds)" },
                ],
                UTILITY: [
                    { value: 30, label: "30 seconds" },
                    { value: 60, label: "1 minute (60 seconds)" },
                    { value: 300, label: "5 minutes (300 seconds)" },
                    { value: 600, label: "10 minutes (600 seconds)" },
                    { value: 1800, label: "30 minutes (1,800 seconds)" },
                    { value: 3600, label: "1 hour (3,600 seconds)" },
                    { value: 7200, label: "2 hours (7,200 seconds)" },
                    { value: 14400, label: "4 hours (14,400 seconds)" },
                    { value: 21600, label: "6 hours (21,600 seconds)" },
                    { value: 43200, label: "12 hours (43,200 seconds)" },
                    { value: -1, label: "30 days (special value: -1)" },
                ],
                AUTHENTICATION: [
                    { value: 30, label: "30 seconds" },
                    { value: 60, label: "1 minute (60 seconds)" },
                    { value: 120, label: "2 minutes (120 seconds)" },
                    { value: 180, label: "3 minutes (180 seconds)" },
                    { value: 300, label: "5 minutes (300 seconds)" },
                    { value: 600, label: "10 minutes (600 seconds)" },
                    { value: 900, label: "15 minutes (900 seconds)" },
                    { value: -1, label: "30 days (special value: -1)" },
                ],
            };
            return options[this.category] || [];
        },
        getTtlInfoText() {
            const info = {
                MARKETING: "Marketing templates: 12 hours to 30 days. Default is system-defined.",
                UTILITY: "Utility templates: 30 seconds to 12 hours, or -1 for 30 days. Default is system-defined.",
                AUTHENTICATION: "Authentication templates: 30 seconds to 15 minutes, or -1 for 30 days. Default is system-defined.",
            };
            return info[this.category] || "";
        },
    },
    methods: {
        handleChange(value) {
            this.$emit('update', value);
        },
    },
});
</script>

<style scoped lang="scss">
.ttl-editor {
    background: #fffbe6;
    border: 1px solid #ffe58f;
    border-radius: 8px;
    padding: 16px;
    margin-top: 16px;

    h4 {
        margin: 0;
        font-size: 14px;
        font-weight: 600;
        color: #333;
        display: flex;
        align-items: center;
    }

    .ttl-description {
        margin: 8px 0 16px 0;
        font-size: 13px;
        color: #666;
        line-height: 1.5;
    }

    .ttl-input-row {
        margin-bottom: 12px;
    }

    .ttl-info {
        display: flex;
        align-items: flex-start;
        gap: 4px;
        font-size: 12px;
        color: #666;
        line-height: 1.6;
        padding: 8px;
        background: #fff;
        border-radius: 4px;
    }
}
</style>
